import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';
import { CompatibilityPopupComponent } from './shared/components/compatibility-popup/compatibility-popup.component';
import { AppConfigService } from './shared/services/app-config.service';
import { AppLoadService } from './shared/services/app-load.service';
import { DynamicTitleService } from './shared/services/dynamic-title.service';
import { AccessibilityService } from './shared/services/accessibility.service';
import { AuthService } from './auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private titleSubscription: Subscription;
  compatibilityDialogRef: MatDialogRef<CompatibilityPopupComponent>;

  constructor(
    private dynamicTitleService: DynamicTitleService,
    private titleService: Title,
    private appLoadService: AppLoadService,
    private appConfigService: AppConfigService,
    private authService: AuthService,
    private dialog: MatDialog,
    accessibilityService: AccessibilityService
  ) {
    //create the live region up front so screen readers register it on first buffer build
    accessibilityService.ensureLiveRegion();
    this.handleBrowserCompatibility();
  }

  ngOnInit(): void {
    this.titleSubscription = this.dynamicTitleService.titleUpdated.subscribe((title: string) => {
      this.titleService.setTitle(title);
    });
    this.authService
      .getProfile()
      .pipe(
        first((profile) => !!profile?.raw),
        switchMap((profile) =>
          this.authService.getPersonId().pipe(map((personId) => ({ profile, personId })))
        )
      )
      .subscribe(({ profile, personId }) => {
        this.dynamicTitleService.initForAuthenticated();
        pendo.initialize({
          visitor: {
            id: profile.userId,
            lineup_person_id: personId,
            name: profile.full_name,
            email: profile.email,
            role: this.authService.getRole(),
            is_staff: this.authService.isStaff(),
            impersonated_by: null
          },
          account: {
            id: this.appConfigService.tenant?.id,
            account_name: this.appConfigService.tenant?.name,
            account_subdomain: this.appConfigService.tenant?.subdomain
          }
        });
      });
  }

  handleBrowserCompatibility() {
    if (!this.appLoadService.isCompatible) {
      this.compatibilityDialogRef = this.dialog.open(CompatibilityPopupComponent);

      this.compatibilityDialogRef.afterClosed().subscribe(() => {
        this.compatibilityDialogRef = null;
      });
    }
  }

  ngOnDestroy(): void {
    this.titleSubscription.unsubscribe();
  }
}
